import {
  yesNoSchema,
  yesNoUI,
  textUI,
  titleUI,
  currentOrPastDateUI,
  currentOrPastDateSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isYes } from '../../../utils/helpers';
import { customTextSchema } from '../../definitions';
import { CourtOrderSeparationAlert } from '../../../components/FormAlerts';
import { validations } from '../../validations';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  title: 'Separation details',
  path: 'household/separation-details',
  uiSchema: {
    ...titleUI(content['household-separation-details-title']),
    separationExplanation: textUI({
      title: content['household-separation-details-explanation'],
      errorMessages: {
        required: content['household-separation-details-explanation-error'],
      },
    }),
    separationStartDate: currentOrPastDateUI({
      title: content['household-separation-details-start-date'],
      monthSelect: false,
    }),
    separationEndDate: currentOrPastDateUI({
      title: content['household-separation-details-end-date'],
      monthSelect: false,
      validations: [validations.isAfterSeparationStartDate],
    }),
    courtOrderedSeparation: yesNoUI({
      title: content['household-separation-details-court-ordered'],
    }),
    courtOrderAlert: {
      'ui:description': CourtOrderSeparationAlert,
      'ui:options': {
        hideIf: formData => !isYes(formData?.courtOrderedSeparation),
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: [
      'separationExplanation',
      'separationStartDate',
      'separationEndDate',
      'courtOrderedSeparation',
    ],
    properties: {
      separationExplanation: customTextSchema,
      separationStartDate: currentOrPastDateSchema,
      separationEndDate: currentOrPastDateSchema,
      courtOrderedSeparation: yesNoSchema,
      courtOrderAlert: {
        type: 'object',
        properties: {},
      },
    },
  },
};
